






























import mixins from 'vue-typed-mixins';
import _ from 'lodash';

import InterniDruhDuvodInput from '../../components/microcomponents/InterniDruhDuvodInput.vue';
import InterniDruhSelect from '../../components/microcomponents/InterniDruhSelect.vue';
import InterniSkupinaProfilSelect from '../../components/microcomponents/InterniSkupinaProfilSelect.vue';
import SlevaInputNumber from '../../components/microcomponents/SlevaInputNumer.vue';
import { EditMixin } from '../../mixins/editMixin';

export default mixins(EditMixin).extend({
	name: 'InterniKarta',
	components: {
		InterniSkupinaProfilSelect,
		InterniDruhSelect,
		InterniDruhDuvodInput,
		SlevaInputNumber,
	},
	computed: {
		edit() {
			const [pages, editModule] = this.storeUri.split('/');
			if (_.isNil(pages) || _.isNil(editModule)) return null;
			return this.$store.state[pages][editModule];
		},
	},
	methods: {
		validateSlevaRowFirst() {
			return (this.edit.IntSlevaMat + this.edit.IntSlevaSlz + this.edit.IntSlevaEmise) === 100;
		},
		validateSlevaRowSecond() {
			return (this.edit.IntSlevaMat + this.edit.IntSlevaSlz + this.edit.IntSlevaEmise) === 100;
		},
	},
});
